import { makeStyles } from '@material-ui/core'
import React, {useEffect, useState} from 'react'
import {Drawer, Form, Select, notification} from 'antd'
import { CTAButton } from '../../components'
import { useData } from '../../../../data'
import { trackPromise, usePromiseTracker } from 'react-promise-tracker'

const useStyles = makeStyles(theme => ({
    error: {
        fontSize: 18,
        color: 'red'
    }
}))

const {Option} = Select

const NewRelevantTitle = ({visible, close}) => {
    const [variationList, setVariationList] = useState([])
    const [error, setError] = useState(null)
    const classes = useStyles()
    const [form] = Form.useForm()
    const data = useData()
    const titles = data.titles()

    // get a list of variations to use 
    const getVariations = async () => {
        try {
            const allVariations = await titles.getVariations()

            setVariationList(allVariations.map(t => ({ id: t.id, initial: t.initial, variations: t.variations })))
            // setNewTools(toolList)
        } catch (error) {
            console.log(error.message)
        }

    }


    /**
     * Get data required 
     */
    useEffect(() => {
        getVariations()
        // eslint-disable-next-line
    }, [])

    const createRelevantTitle = vals => {
        console.log("vals creater: ", vals)
        trackPromise(
            titles.createRelevantTitle(vals)
                .then(()=>{
                    close();
                    notification.success({
                        message: "Relevant title created successfully."
                    })
                })
                .catch(err => {
                    console.log(err)
                    if('detail' in err){
                        setError(err.detail)
                    }
                    setError("An error occured.")
                })
        )
    }

    const {promiseInProgress} = usePromiseTracker()
    
    return (
        <Drawer
            visible={visible}
            onClose={close}
            placement="right"
            closable={true}
            width={350}
            title="Create a relevant title"
        >
            <Form
                layout="vertical"
                onFinish={createRelevantTitle}
                form={form}
            >
                <Form.Item label="Initial" name="initial" rules={[{ required: false}]}>
                    <Select
                        showSearch
                        placeholder="Select a initial"
                        optionFilterProp="children"
                        filterOption={(input, option) => option.key.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                            option.title.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                    >
                        {
                            variationList.map(t => <Option title={t.variations} value={t.id} key={t.id}>{t.initial} - {t.variations}</Option>)
                        }
                    </Select>
                </Form.Item>
                <Form.Item label="Main" name="main" rules={[{ required: false}]}>
                    <Select
                        showSearch
                        placeholder="Select a main"
                        optionFilterProp="children"
                        filterOption={(input, option) => option.key.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                            option.title.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                    >
                        {
                            variationList.map(t => <Option title={t.variations} value={t.id} key={t.id}>{t.initial} - {t.variations}</Option>)
                        }
                    </Select>
                </Form.Item>
                <Form.Item label="End" name="end" rules={[{ required: false}]}>
                    <Select
                        showSearch
                        placeholder="Select a end"
                        optionFilterProp="children"
                        filterOption={(input, option) => option.key.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                            option.title.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                    >
                        {
                            variationList.map(t => <Option title={t.variations} value={t.id} key={t.id}>{t.initial} - {t.variations}</Option>)
                        }
                    </Select>
                </Form.Item>

                <Form.Item>
                    <CTAButton loading={promiseInProgress} type="submit"><>Submit</></CTAButton>
                </Form.Item>
                {
                    error && (
                        <Form.Item>
                            <p className={classes.error}>{error}</p>
                        </Form.Item>
                    )
                }

            </Form>
        </Drawer>
    )
}

export default NewRelevantTitle
